export enum GRADIENT {
  LINEAR = 'LINEAR',
  RADIAL = 'RADIAL'
};


// WEBPACK FOOTER //
// ./src/constants.ts